export default {
    advancedSearchLink: 'advancedSearchLink',
    alternateText: 'alternateText',
    baggageDetailLink: 'baggageDetailLink',
    colorCell: 'colorCell',
    checkmark: 'checkmark',
    dashboardLink: 'dashboardLink',
    dateTime: 'dateTime',
    duration: 'duration',
    flightDetailLink: 'flightDetailLink',
    inboundUnloadedBagCargoCountLink: 'inboundUnloadedBagCargoCountLink',
    inboundToUnloadBagCargoCountStatusLink:
        'inboundToUnloadBagCargoCountStatusLink',
    outboundToLoadBagCargoCountStatusLink:
        'outboundToLoadBagCargoCountStatusLink',
    outboundLoadedBagCargoCountLink: 'outboundLoadedBagCargoCountLink',
    percent: 'percent',
    placeholder: 'placeholder',
    passengerDetailLinkWithPassengerId: 'passengerDetailLinkWithPassengerId',
    stackedBar: 'stackedBar',
    staticParentHeader: 'staticParentHeader',
    statusIcon: 'statusIcon',
    text: 'text',
    tracerReferenceLink: 'tracerReferenceLink',
    thresholdCompare: 'thresholdCompare',
    linkWithParameters: 'linkWithParameters',
};
